// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"d3ee193b","264":"7855799d","480":"9d7c1c6b","638":"7e671688","738":"89e4cfd7"}[chunkId] + ".chunk.js";
};